import { monitoringConstants } from "../_constants";

export default function monitoringUnits(state = {}, action) {
  switch (action.type) {
    case monitoringConstants.GET_IP_ADDRESS_MONITORING_LIST_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case monitoringConstants.GET_IP_ADDRESS_MONITORING_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        ipAddressList: action?.user?.data,
      };
    case monitoringConstants.GET_IP_ADDRESS_MONITORING_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    case monitoringConstants.GET_COUNTRY_CODE_LIST_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case monitoringConstants.GET_COUNTRY_CODE_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        countryList: action?.user?.data,
      };
    case monitoringConstants.GET_COUNTRY_CODE_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    case monitoringConstants.GET_IP_ADDRESS_WHITE_AND_BLACK_LISTING_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case monitoringConstants.GET_IP_ADDRESS_WHITE_AND_BLACK_LISTING_SUCCESS:
      return {
        ...state,
        loading: false,
        whiteBlackList: action?.user?.data,
      };
    case monitoringConstants.GET_IP_ADDRESS_WHITE_AND_BLACK_LISTING_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    case monitoringConstants.GET_TRANSACTION_MONITORING_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case monitoringConstants.GET_TRANSACTION_MONITORING_SUCCESS:
      return {
        ...state,
        loading: false,
        transactionList: action?.user?.data,
      };
    case monitoringConstants.GET_TRANSACTION_MONITORING_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    case monitoringConstants.GET_FEES_MONITORING_LIST_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case monitoringConstants.GET_FEES_MONITORING_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        feesAnalysisList: action?.user?.data,
      };
    case monitoringConstants.GET_FEES_MONITORING_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    case monitoringConstants.GET_WEB_STORES_MONITORING_LIST_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case monitoringConstants.GET_WEB_STORES_MONITORING_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        webStoresList: action?.user?.data,
      };
    case monitoringConstants.GET_WEB_STORES_MONITORING_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    case monitoringConstants.GET_USER_CREDIT_SCORE_MONITORING_LIST_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case monitoringConstants.GET_USER_CREDIT_SCORE_MONITORING_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        userCreditScoreMonitoringList: action?.user?.data,
      };
    case monitoringConstants.GET_USER_CREDIT_SCORE_MONITORING_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    default:
      return state;
  }
}
